import { makeRequest } from "./api";

export function fetchConversations({ page, limit }) {
  return makeRequest(`/api/inbox/all?page=${page}&limit=${limit}`);
}

export function fetchMessages({ limit, currentPage, conversationId }) {
  return makeRequest(
    `/api/chat/get-messages?conversationId=${conversationId}&page=${currentPage}&limit=${limit}`,
  );
}

export function sendMessage({ conversationId, content }) {
  return makeRequest(`/api/chat/send-message`, {
    method: "post",
    data: { conversationId, content },
  });
}
